import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';

import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import LearningAdminModuleSerieForm from '../containers/LearningAdminModuleSerieFormContainer';
import {
  MixpanelTracker,
  mixpanelEventsEnum,
} from '../../../../../lib/Mixpanel';

const LearningAdminModuleSerieEditScreen = ({
  history,
  location,
  role,
  ...props
}) => {
  const scrollToTop = () => {
    Logger.log('debug', `LearningAdminModuleSerieEditScreen.sEditllToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  const trackerActions = (eventMixpanel, params = {}) => {
    if (role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: props.partnershipName ?? 'No partnership',
        partnershipId: props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  useEffect(() => {
    scrollToTop();
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER
        .LEARNINGS_ADMIN_EDIT_SCREEN_MODULE_SERIE
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Translation>
      {(t) => (
        <div>
          <DocumentHead title={t('learnings_route_edit')} />
          <LearningAdminModuleSerieForm
            id={props.match.params.id}
            history={history}
            location={location}
            screen='edit'
            trackerActions={trackerActions}
          />
        </div>
      )}
    </Translation>
  );
};

export default LearningAdminModuleSerieEditScreen;

Logger.log('silly', `LearningAdminModuleSerieEditScreen loaded.`);
